import { isVisionLocal } from '@common/core/utils/isVisionLocal'

import { getBrowserHostname } from './getBrowserHostname'
import { isLocalHostname } from './isLocalHostname'

export function isLocalGatewayConfigurationMode(): boolean {
  if (isVisionLocal()) {
    return true
  }

  if (!process.env.NEXT_PUBLIC_GATEWAY_URL?.trim()) {
    return true
  }

  const hostname = getBrowserHostname()
  if (hostname && isLocalHostname(hostname)) {
    return true
  }

  return false
}
